/* BCF Klaviyo onsite tracking. Two jobs only:
   1) identify the browser to Klaviyo after the email popup captures an address
      (stored in localStorage before Shopify's form post navigates away);
   2) send "Added to Cart" on every real /cart/add network call so the
      abandoned-cart flow has a trigger. Events attach to a profile only once
      the browser is identified, which mirrors who the flow could email anyway. */
(function () {
  if (window.__bcfKlaviyoTracking) return;
  window.__bcfKlaviyoTracking = true;

  window._learnq = window._learnq || [];
  if (!document.querySelector('script[src*="static.klaviyo.com/onsite"]')) {
    var loader = document.createElement('script');
    loader.async = true;
    loader.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=TRmq3e';
    document.head.appendChild(loader);
  }

  var stored = null;
  try { stored = window.localStorage.getItem('bcf-klaviyo-identify'); } catch (error) {}
  if (stored) {
    window._learnq.push(['identify', { $email: stored }]);
    try { window.localStorage.removeItem('bcf-klaviyo-identify'); } catch (error) {}
  }

  /* The cart pixel is known to multi-fire; throttle per variant so one add
     produces one Klaviyo event. */
  var recentAdds = {};
  function trackAddedItem(item) {
    if (!item || !item.product_id) return;
    var key = String(item.variant_id || item.id || item.product_id);
    var now = Date.now();
    if (recentAdds[key] && now - recentAdds[key] < 8000) return;
    recentAdds[key] = now;
    window._learnq.push(['track', 'Added to Cart', {
      ItemName: item.product_title || item.title || '',
      ProductID: item.product_id,
      VariantID: item.variant_id || item.id,
      SKU: item.sku || '',
      URL: item.url ? window.location.origin + item.url : window.location.href,
      ImageURL: item.image || '',
      Price: (item.price || 0) / 100,
      Quantity: item.quantity || 1,
      $value: ((item.price || 0) / 100) * (item.quantity || 1)
    }]);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var url = target && (typeof target === 'string' ? target : target.url) || '';
    var pending = originalFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      pending.then(function (response) {
        if (!response || !response.ok) return;
        response.clone().json().then(function (data) {
          var items = data && data.items ? data.items : [data];
          items.forEach(trackAddedItem);
        }).catch(function () {});
      }).catch(function () {});
    }
    return pending;
  };
})();
